/* unplugin-vue-components disabled */import { render } from "./source-tag.vue?vue&type=template&id=753a2826&scoped=true"
import script from "./source-tag.vue?vue&type=script&lang=js"
export * from "./source-tag.vue?vue&type=script&lang=js"

import "./source-tag.vue?vue&type=style&index=0&id=753a2826&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753a2826"],['__file',"src/components/sources-v2/source-tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "753a2826"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('753a2826', __exports__)) {
    api.reload('753a2826', __exports__)
  }
  
  module.hot.accept("./source-tag.vue?vue&type=template&id=753a2826&scoped=true", () => {
    api.rerender('753a2826', render)
  })

}


export default __exports__